module.exports = __webpack_public_path__ + "static/img/jkgl.0cc4e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/jkgl.png
// module id = UtOD
// module chunks = 1